
import { Button } from "primereact/button";
import { useEffect, useState } from "react";

import getNotificacao from '../../service/getNotificacao';
import { Sidebar } from "primereact/sidebar";
import Divider from "./Divider";
import { Checkbox } from "primereact/checkbox";
import patchNotificacaoVisualizado from "../../service/patchNotificacaoVisualizado";
import { useGlobalState } from "../globalState/GlobalStateProvider";
import { GlobalSaveData } from "../globalState/GlobalSaveData";

const TopbarNotificacao = () => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [notificacoes, setNotificacoes] = useState([]);
  const {state} = useGlobalState();
  const loadLazyData = () => {
    getNotificacao().then(data => {setNotificacoes(data)}).catch(() => {setNotificacoes([])});
  }

  const salvarVisualizado = (id:string) => {
    patchNotificacaoVisualizado(id)
    .then(()=> { loadLazyData();})
    .catch(()=> {});
  }


  useEffect(() => {
    if(state.verifyNotificacao) return;
    state.verifyNotificacao = true;
    GlobalSaveData("verifyNotificacao", true)
    getNotificacao().then(data => {setNotificacoes(data);if(data.filter((s:any)=>!s.visualizado).length > 0){setDialogVisible(true)}}).catch(() => {setNotificacoes([])});
  },[])

  return (
    <div>
      <Button className="button_relatorio" onClick={() => {loadLazyData();setDialogVisible(true)}} icon="pi pi-megaphone" badgeClassName="p-badge-danger badge_relatorio" rounded text style={{color:'white'}} ></Button>
      <Sidebar visible={dialogVisible} position="right" onHide={() => setDialogVisible(false)} className="md:w-20rem lg:w-30rem">
          {notificacoes && notificacoes.length > 0 && notificacoes.map((notificacao:any) => (
            <div key={notificacao.id} style={{marginBottom:'20px', textAlign:'left'}}>
              <h4>{notificacao.titulo}</h4>
              <Divider></Divider>
              <div className="notificacao-conteudo" style={{textAlign:'center'}} dangerouslySetInnerHTML={{ __html: notificacao.conteudo }}></div>
              <hr />
              {!notificacao.visualizado ? (<div style={{textAlign:'left'}}><Checkbox inputId="visualizado" onChange={e => salvarVisualizado(notificacao.id)} checked={notificacao.visualizado}/> Marcar como visuzalizado</div>) : (<p>Visualizado</p>)}
            </div>
          ))}
      </Sidebar>
    </div>
  );
};

export default TopbarNotificacao;
